import ActivityEntity from "./activityEntity";
import ActivityWindow from "./activityWindow";
import { WindowDefinition } from "./windowDefinition";
import Activity from "./activity";
import { Glue42 } from "../../../glue";

/**
 * A window type is a definition of a window, typically configured in ACS.
 *
 * @module windowType
 */
export default class WindowType extends ActivityEntity {

  public _name: string;
  public _appByWindowTypeGetter: (name: string) => void;

  constructor(name: string, appByWindowTypeGetter: (wt: string) => Glue42.AppManager.Application) {
    super(name);
    this._name = name;
    this._appByWindowTypeGetter = appByWindowTypeGetter;
  }

  /**
   * Name of the window type
   * @var {string} name
   */
  public get name(): string {
    return this._name;
  }

  /**
   * Returns the ACS configuration related to this window type (as application object from AppManager API)
   * @returns {any}
   */
  public get config(): any {
    return this._appByWindowTypeGetter(this._name);
  }

  /**
   * @var {activityWindow[]} windows All windows from that type
   */
  public get windows(): ActivityWindow[] {
    return this._manager.getWindows({ type: this._name });
  }

  public create(activity: Activity, configuration: any): Promise<ActivityWindow> {
    const definition: WindowDefinition = (Object as any).assign({ type: this.name, name: this.name, isIndependent: false }, configuration);
    return this._manager.createWindow(activity, definition);
  }
}
